module.exports = __webpack_public_path__ + "img/realtor-r-footer.d6a4ea36.svg";